import BasePerimeter from '@/perimeters/BasePerimeter';

export default new BasePerimeter({
  purpose: 'investigator',

  can: {
    all() {
      return this.hasPermission('investigator-read');
    },

    create() {
      return this.hasPermission('investigator-write');
    },

    read() {
      return this.hasPermission('investigator-read');
    },

    update(investigator) {
      return (
        this.isCreator(investigator) ||
        this.hasPermission('investigator-update')
      );
    },

    destroy() {
      return this.hasPermission('investigator-delete');
    }
  },

  isCreator(investigator) {
    if (!investigator) return false;

    return this.child.id === investigator.child_id;
  }
});
